import { convertFromRaw } from "draft-js";
import PropTypes from "prop-types";
import React from "react";
import i18n from "i18next";

import { DefaultRowCell } from "./../../Layout/SortedList";
import { formatNotificationDate } from "../../../helpers/dateHelpers";
import ActionsListCell from "./ActionsListCell";

const lineBreakRegex = /(\r\n|\n|\r)/gm;

const ListRow = ({ item: { created, expired, id, message, messageType, sender }, onDeleteClick, userMetadata }) => {
  const handleClick = () => onDeleteClick(id);

  const displayText = convertFromRaw(JSON.parse(message))
    .getPlainText()
    .replace(lineBreakRegex, " ");

  return (
    <div role="row" tabIndex="0" className="sorted-list__row">
      <DefaultRowCell className="--first --x6" value={sender} />
      <DefaultRowCell className="--x2" value={formatNotificationDate(created, userMetadata.dateDisplayFormat)} />
      <DefaultRowCell className="--x2" value={formatNotificationDate(expired, userMetadata.dateDisplayFormat)} />
      <DefaultRowCell className="--x2" value={i18n.t(`notification.${messageType}`)} />
      <DefaultRowCell className="--x6" value={displayText} />
      <ActionsListCell id={id} onClick={handleClick} className="--x2" />
    </div>
  );
};

ListRow.propTypes = {
  item: PropTypes.object.isRequired,
  onDeleteClick: PropTypes.func,
  userMetadata: PropTypes.object
};

export default ListRow;



// WEBPACK FOOTER //
// ./src/components/Notifications/List/ListRow.js